module.exports = __webpack_public_path__ + "static/media/bitlogoimg.158ed124.svg";